(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[data-openaxis-chat]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const deadline = Date.now() + 4000;
    function openChat() {
      const chat = document.querySelector('shopify-chat');
      const root = chat && chat.shadowRoot;
      const runtime = root && root.querySelector('shopify-agent-runtime');
      const launcher = root && (root.querySelector('button[part="activator"]') ||
        (runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector('button[part="activator"]')));
      if (launcher) {
        if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
        return;
      }
      if (Date.now() < deadline) {
        setTimeout(openChat, 150);
      } else {
        window.location.assign(link.href);
      }
    }
    openChat();
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oa-lead-time-table"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oa-lead-time-table')) {
    customElements.define('oa-lead-time-table', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
      }
      initialize() {
        this.events?.abort();
        const rows = [...this.querySelectorAll('[data-lead-time-row]')];
        const search = this.querySelector('[data-search-input]');
        const select = this.querySelector('[data-manufacturer-filter]');
        const filters = this.querySelector('[data-filters]');
        const reset = this.querySelector('[data-reset]');
        const count = this.querySelector('[data-result-count]');
        const empty = this.querySelector('[data-no-results]');
        if (!rows.length || !search || !select || !filters || !reset || !count || !empty) return;
        const normalize = value => value.normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase().trim();
        const entries = rows.map(row => ({ row, search: normalize(row.dataset.search || ''), manufacturer: normalize(row.dataset.manufacturer || '') }));
        const manufacturers = new Map();
        rows.forEach(row => {
          const label = (row.dataset.manufacturer || '').trim();
          if (label && !manufacturers.has(normalize(label))) manufacturers.set(normalize(label), label);
        });
        while (select.options.length > 1) select.remove(1);
        [...manufacturers.entries()].sort((a, b) => a[1].localeCompare(b[1])).forEach(([value, label]) => select.add(new Option(label, value)));
        select.closest('.oa-lead-time__field').hidden = manufacturers.size === 0;
        const update = () => {
          const terms = normalize(search.value).split(/\s+/).filter(Boolean);
          let visible = 0;
          entries.forEach(entry => {
            const match = (!select.value || entry.manufacturer === select.value) && terms.every(term => entry.search.includes(term));
            entry.row.hidden = !match;
            if (match) visible += 1;
          });
          empty.hidden = visible > 0;
          count.textContent = (this.dataset.countMessage || '').replace('{count}', String(visible));
        };
        const clear = () => { search.value = ''; select.value = ''; update(); };
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        search.addEventListener('input', update, options);
        select.addEventListener('change', update, options);
        reset.addEventListener('click', () => { clear(); search.focus(); }, options);
        this.addEventListener('shopify:block:select', clear, options);
        filters.hidden = false;
        count.hidden = false;
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["openaxis-manufacturer-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDirectory = (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const directory = root.querySelector('[data-directory]');
      const summary = root.querySelector('[data-summary]');
      const categoryList = root.querySelector('[data-category-list]');
      const categoryToggle = root.querySelector('[data-category-toggle]');
      const categoryLabel = root.querySelector('[data-category-label]');
      const defaultCategoryLabel = categoryLabel.textContent;
      const categoryContainer = categoryToggle.closest('.oa-manufacturers__categories');
      const letterButtons = [...root.querySelectorAll('button[data-letter]')];
      const viewButtons = [...root.querySelectorAll('button[data-view]')];
      const cards = [...root.querySelectorAll('[data-manufacturer]')].sort((a, b) => a.dataset.name.localeCompare(b.dataset.name));
      const cardCategories = new Map(cards.map((card) => [card, (card.dataset.categories || '').split(',').map((item) => item.trim().toLowerCase()).filter(Boolean)]));
      const categoryNames = [...new Set(cards.flatMap((card) => (card.dataset.categories || '').split(',').map((item) => item.trim()).filter(Boolean)))].sort((a, b) => a.localeCompare(b));
      cards.forEach((card) => directory.append(card));
      categoryNames.forEach((name) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.category = name.toLowerCase();
        button.setAttribute('aria-pressed', 'false');
        button.textContent = name;
        categoryList.append(button);
      });
      const categoryButtons = [...categoryList.querySelectorAll('button[data-category]')];
      const availableLetters = new Set(cards.map((card) => card.dataset.letter));
      letterButtons.forEach((button) => { button.disabled = button.dataset.letter !== 'all' && !availableLetters.has(button.dataset.letter); });
      let letter = 'all';
      let category = 'all';
      const closeCategoryPanel = () => {
        categoryContainer.classList.remove('is-open');
        categoryToggle.setAttribute('aria-expanded', 'false');
      };
      const alignDirectoryBelowToolbar = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const toolbar = root.querySelector('.oa-manufacturers__toolbar');
            const stickyTop = Number.parseFloat(window.getComputedStyle(toolbar).top) || 0;
            const targetTop = window.scrollY + directory.getBoundingClientRect().top - stickyTop - toolbar.getBoundingClientRect().height - 14;
            window.scrollTo({ top: Math.max(0, targetTop), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          });
        });
      };
      const syncControls = () => {
        letterButtons.forEach((button) => {
          const active = button.dataset.letter === letter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        categoryButtons.forEach((button) => {
          const active = button.dataset.category === category;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        categoryLabel.textContent = category === 'all' ? defaultCategoryLabel : categoryNames.find((name) => name.toLowerCase() === category) || defaultCategoryLabel;
      };
      const update = () => {
        let count = 0;
        cards.forEach((card) => {
          const matches = (letter === 'all' || card.dataset.letter === letter) && (category === 'all' || cardCategories.get(card).includes(category));
          card.hidden = !matches;
          if (matches) count += 1;
        });
        const countTemplate = count === 1 ? summary.dataset.countOne : summary.dataset.countOther;
        summary.textContent = countTemplate.replace('__count__', String(count));
        root.querySelector('[data-empty]').hidden = count > 0;
      };
      root.addEventListener('click', (event) => {
        const sidebarCategory = event.target.closest('button[data-category]');
        const letterButton = event.target.closest('button[data-letter]');
        const viewButton = event.target.closest('button[data-view]');
        const resetButton = event.target.closest('button[data-reset-filters]');
        if (sidebarCategory) {
          category = sidebarCategory.dataset.category;
          letter = 'all';
          syncControls();
          closeCategoryPanel();
          update();
          alignDirectoryBelowToolbar();
        } else if (letterButton) {
          letter = letterButton.dataset.letter;
          syncControls();
          update();
          alignDirectoryBelowToolbar();
        } else if (viewButton) {
          directory.dataset.currentView = viewButton.dataset.view;
          viewButtons.forEach((button) => {
            const active = button === viewButton;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
        } else if (resetButton) {
          letter = 'all';
          category = 'all';
          syncControls();
          closeCategoryPanel();
          update();
          alignDirectoryBelowToolbar();
        }
      });
      categoryToggle.addEventListener('click', () => {
        const open = categoryContainer.classList.toggle('is-open');
        categoryToggle.setAttribute('aria-expanded', String(open));
      });
      syncControls();
      update();
    };
    document.querySelectorAll('[data-oa-manufacturers]').forEach(initializeDirectory);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-oa-manufacturers]').forEach(initializeDirectory);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["openaxis-rfq-confirmation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const focusConfirmation = (section) => {
      if (section.hidden) return;
      const heading = section.querySelector('[data-rfq-confirmation]');
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      heading?.focus({ preventScroll: true });
      window.scrollTo({
        top: Math.max(0, section.getBoundingClientRect().top + window.scrollY - headerHeight),
        behavior: 'instant'
      });
    };

    const initializeConfirmation = () => {
      const submitted = document.querySelector('[data-rfq-submitted]');
      const formSection = submitted?.closest('[data-openaxis-rfq]');
      document.querySelectorAll('[data-rfq-confirmation-section]').forEach((section) => {
        if (submitted && formSection && !submitted.dataset.rfqReopened) {
          section.hidden = false;
          section.classList.remove('hidden');
          submitted.hidden = true;
          if (section.dataset.rfqCollapseForm === 'true') {
            formSection.hidden = true;
            formSection.classList.add('hidden');
            formSection.dataset.rfqCollapsed = 'true';
          }
          if (!section.dataset.announced) {
            section.dataset.announced = 'true';
            const confirmationUrl = new URL(window.location.href);
            confirmationUrl.hash = section.id;
            window.history.replaceState(window.history.state, '', confirmationUrl);
            requestAnimationFrame(() => focusConfirmation(section));
            if (document.readyState !== 'complete') {
              window.addEventListener('load', () => focusConfirmation(section), { once: true });
            }
          }
        }

        const returnLink = section.querySelector('[data-rfq-return-to-form]');
        if (returnLink && !returnLink.dataset.initialized) {
          returnLink.dataset.initialized = 'true';
          returnLink.addEventListener('click', (event) => {
            const firstField = document.getElementById('RfqFirstName');
            if (!firstField) return;
            event.preventDefault();
            if (submitted && formSection) {
              submitted.dataset.rfqReopened = 'true';
              if (formSection.dataset.rfqCollapsed) {
                formSection.hidden = false;
                formSection.classList.remove('hidden');
                delete formSection.dataset.rfqCollapsed;
              }
              section.hidden = true;
              section.classList.add('hidden');
              const formUrl = new URL(window.location.href);
              formUrl.searchParams.delete('contact_posted');
              formUrl.hash = 'OpenAxisRfqForm';
              window.history.replaceState(window.history.state, '', formUrl);
            }
            firstField.focus({ preventScroll: true });
            firstField.closest('fieldset')?.scrollIntoView({ block: 'start', behavior: 'instant' });
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeConfirmation, { once: true });
    } else {
      initializeConfirmation();
    }
    document.addEventListener('shopify:section:load', initializeConfirmation);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["openaxis-rfq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRfq = () => document.querySelectorAll('[data-openaxis-rfq]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form');
      if (!form) return;
      const guidance = root.querySelector('.oa-rfq__guidance');
      if (guidance && window.matchMedia('(max-width: 1099px)').matches) guidance.open = false;
      const productList = root.querySelector('[data-product-list]');
      const productTemplate = root.querySelector('[data-product-template]');

      const renumberProducts = () => {
        productList.querySelectorAll('[data-product-row]').forEach((row, rowIndex) => {
          const number = rowIndex + 1;
          row.querySelector('[data-product-number]').textContent = number;
          row.querySelectorAll('[data-field]').forEach((field) => {
            const suffix = field.dataset.field;
            const label = row.querySelector(`label[for="${field.id}"]`);
            field.id = `RfqProduct-${suffix}-${number}`;
            field.name = `contact[Product ${number} ${suffix.replace('-', ' ')}]`;
            if (label) label.htmlFor = field.id;
          });
          row.querySelector('[data-remove-product]').hidden = rowIndex === 0;
        });
      };

      root.querySelector('[data-add-product]')?.addEventListener('click', () => {
        const fragment = productTemplate.content.cloneNode(true);
        fragment.querySelectorAll('input, select').forEach((field) => field.value = '');
        productList.append(fragment);
        renumberProducts();
        productList.lastElementChild.querySelector('select, input')?.focus();
      });

      root.querySelector('[data-duplicate-product]')?.addEventListener('click', () => {
        const source = productList.lastElementChild;
        if (!source) return;
        const duplicate = source.cloneNode(true);
        const sourceFields = source.querySelectorAll('input, select, textarea');
        const duplicateFields = duplicate.querySelectorAll('input, select, textarea');
        sourceFields.forEach((field, index) => {
          duplicateFields[index].value = field.value;
        });
        productList.append(duplicate);
        renumberProducts();
        duplicate.querySelector('select, input')?.focus();
      });

      productList?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-remove-product]');
        if (!button) return;
        button.closest('[data-product-row]').remove();
        renumberProducts();
      });

      const urgency = root.querySelector('[data-urgency]');
      const neededDate = root.querySelector('[data-needed-date]');
      const neededDateInput = root.querySelector('[data-needed-date-input]');
      const toggleDate = () => {
        if (!urgency || !neededDate || !neededDateInput) return;
        const visible = urgency?.value === 'By a specific date';
        neededDate.hidden = !visible;
        neededDateInput.required = visible;
        neededDateInput.setAttribute('aria-required', String(visible));
        if (!visible) neededDateInput.value = '';
      };
      urgency?.addEventListener('change', toggleDate);
      toggleDate();

      form.addEventListener('submit', (event) => {
        const errorBox = root.querySelector('[data-client-errors]');
        const errorList = root.querySelector('[data-error-list]');
        errorList.replaceChildren();
        errorBox.hidden = true;
        root.querySelectorAll('[aria-invalid]').forEach((field) => field.removeAttribute('aria-invalid'));
        const invalid = [...form.querySelectorAll('input:invalid, select:invalid, textarea:invalid')];
        if (invalid.length) {
          event.preventDefault();
          invalid.forEach((field) => {
            field.setAttribute('aria-invalid', 'true');
            const item = document.createElement('li');
            const label = root.querySelector(`label[for="${field.id}"]`);
            item.textContent = `${label?.textContent.trim() || field.name}: ${field.validationMessage}`;
            errorList.append(item);
          });
          errorBox.hidden = false;
          errorBox.focus();
        }
      });

      root.querySelector('[data-server-errors]')?.focus();
    });
    initializeRfq();
    document.addEventListener('shopify:section:load', initializeRfq);
  })();

  } catch(e) { console.error(e); }
})();
})();
